// extracted by mini-css-extract-plugin
export default {"v-sky":"#E1F4FF","v-graphite":"#4A4A4A","link":"common-dropdown__link__F85Vt","list":"common-dropdown__list__foxPb","listItem":"common-dropdown__listItem__nZ4rA"};